export const FILE_UPLOAD_SUCCESS = 'FILE_UPLOAD_SUCCESS';
export const FILE_UPLOAD_START = 'FILE_UPLOAD_START';
export const FILE_UPLOAD_ERROR = 'FILE_UPLOAD_ERROR';

export const SELECT_FILES = 'SELECT_FILES';
export const REMOVE_FILES = 'REMOVE_FILES';
export const SELECT_SINGLE_FILE = 'SELECT_SINGLE_FILE';
export const REMOVE_SINGLE_FILE = 'REMOVE_SINGLE_FILE';

export interface FileUploadStart {
  type: typeof FILE_UPLOAD_START;
}

export interface FileUploadSuccess {
  type: typeof FILE_UPLOAD_SUCCESS;
}

export interface FileUploadError {
  type: typeof FILE_UPLOAD_ERROR;
}

export interface SelectFiles {
  type: typeof SELECT_FILES;
  selectedFiles: readonly File[];
}

export interface RemoveFiles {
  type: typeof REMOVE_FILES;
  index: number;
}

export interface SelectSingleFile {
  type: typeof SELECT_SINGLE_FILE;
  selectedFile: any;
  index: number;
}

export interface RemoveSingleFile {
  type: typeof REMOVE_SINGLE_FILE;
  index: number;
}

export type UploaderActionTypes =
  | FileUploadStart
  | FileUploadSuccess
  | FileUploadError
  | SelectFiles
  | RemoveFiles
  | SelectSingleFile
  | RemoveSingleFile;

export interface UploaderState {
  uploading: boolean;
  uploadError: boolean;
  selectedFiles: readonly any[];
  uploadedFiles: readonly any[];
}
